<template>
  <div :class="divWidthChange" class="conteudoWidth fccUsuarios">
    <fccTitlePage :titlePage="titlePage"></fccTitlePage>

    <fccTable
      striped
      hover
      :fields="fields"
      :status="status"
      responsive
      :porPage="itemPorPage"
      search
      pagination
      fieldVisibility
      pdf
      csv
      xls
      :titlePage="titlePage"
      :titlePDF="titlePDF"
      :actions="actions"
      addFilter
      :items="usuarioListandoInterno"
    />
    <fccPermissoes
      title="Permissões do usuário "
      :DataItem="permissaoUsuario"
      :nomeAdmin="nomeAdmin"
      :titlePage="titleUsuario"
      TipoTabela="2"
      idModal="listaPermissao"
      :dataTable="filtroGruposUsuario"
      respostaNegativa="Não há grupos para esse usuário"
    ></fccPermissoes>

    <fccModal
      centered
      idModal="editUser"
      size="xl"
      :titleModal="titleModal"
      escondeFooter
      travaEsc
      travaBack
    >
      <fccUsuariosCadastroVue
        :usuarioListandoInterno="usuarioListandoInterno"
        :usuarios="usuarios"
        :usuarioComplemento="usuarioComplemento"
        :formActive="formActive"
        @limpaIntra="limpaIntra"
        ref="ediLUser"
        @usuariosListandoInterno="usuariosListandoInterno"
      />
    </fccModal>
  </div>
</template>

<script>
import axios from 'axios'
import store from '@/store'
import fccPermissoes from '../../fccComponents/fccListaPermissoes.vue'
import './assets/fccUsuarios.scss'
import fccUsuariosCadastroVue from './fccUsuariosCadastro.vue'

export default {
  components: { fccUsuariosCadastroVue, fccPermissoes },
  data() {
    return {
      titleUsuario: 'Grupos do Usuário',
      nomeAdmin: '',
      allUsers: '',
      userGroups: [],
      permissaoUsuario: [],
      gruposDoUsuario: [],
      status: [
        {
          funcaoButton: 'changeStatus',
          tooltip: 'Alterar Status',
          campoStatus: 'usuativo',
          objpermCodigo: store.state.permissaoMenu.editar
        }
      ],
      fields: [
        { key: 'usuid', label: 'Login', sortable: true, active: true },
        {
          key: 'usuariocomplemento.usucompdocto',
          label: 'CPF',
          sortable: true,
          active: true,
          type: 'sub',
          sub: { sub1: 'usuariocomplemento', sub2: 'usucompdocto' }
        },
        {
          key: 'usuariocomplemento.usucompnome',
          label: 'Nome',
          sortable: true,
          active: true,
          type: 'sub',
          sub: { sub1: 'usuariocomplemento', sub2: 'usucompnome' }
        },
        {
          key: 'usuariocomplemento.usucompsgsetor',
          label: 'Departamento',
          sortable: true,
          active: true,
          type: 'sub',
          sub: { sub1: 'usuariocomplemento', sub2: 'usucompsgsetor' }
        },
        {
          key: 'usubloqueioadm',
          label: 'Bloqueio',
          active: true,
          type: 'toggle',
          funcaoButton: 'desbloqueio',
          objpermCodigo: store.state.permissaoMenu.editar
        },
        {
          key: 'status',
          label: 'Status',
          sortable: true,
          tdClass: 'no-print',
          thClass: 'no-print',
          active: true
        },
        { key: 'actions', label: '', tdClass: 'no-print', thClass: 'no-print', active: true }
      ],
      actions: [
        {
          button: true,
          funcaoButton: 'editUser',
          icon: 'edit',
          tooltip: 'Editar',
          objpermCodigo: store.state.permissaoMenu.adicionar
        },
        {
          button: true,
          funcaoButton: 'resetarSenha',
          icon: 'key',
          tooltip: 'Resetar Senha',
          objpermCodigo: store.state.permissaoMenu.adicionar
        },
        {
          button: true,
          funcaoButton: 'boasVindas',
          icon: 'envelope',
          tooltip: 'Boas Vindas',
          objpermCodigo: store.state.permissaoMenu.adicionar
        },
        {
          button: true,
          funcaoButton: 'deleteUser',
          icon: 'trash',
          tooltip: 'Excluir',
          objpermCodigo: store.state.permissaoMenu.excluir
        },
        {
          button: true,
          funcaoButton: 'listaPermissaoUsuario',
          icon: 'lock',
          tooltip: 'Permissões',
          objpermCodigo: store.state.permissaoMenu.excluir
        }
      ],
      fechaPesquisa: '',
      sortBy: 'ordem',
      usuarioListandoInterno: [],
      titlePage: 'Usuários Internos',
      titleModal: '',
      formActive: false,
      titlePDF: 'Usuários',
      listaUrl: store.state.albumfamilia,
      usuarios: {},
      usuarioComplemento: {},
      data: [],
      valueGrupo: {},
      usuariosGrupos: [],
      itemPorPage: '100',
      emularPermite: false
    }
  },
  computed: {
    filtroGruposUsuario() {
      return this.userGroups.filter((item) => item.usuid === this.allUsers)
    }
  },
  methods: {
    desbloqueio(_, item) {
      const mensagem = item.usubloqueioadm
        ? 'Usuário bloqueado com sucesso?'
        : 'Usuário desbloqueado com sucesso?'
      this.bloqueioUserGenerico(item)
        .then((response) => {
          this.usuariosListandoInterno()

          this.callAlert('Sucesso', mensagem, response.data)
        })
        .catch((error) => {
          this.setErrorSystem(error)
        })
    },
    usuariosListandoInterno: function () {
      this.carregaTexto(this.codeMensagem('C01'))
      axios
        .get(
          this.baseUrlSecurity + 'Cadastro/listartodoslogininterno',
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.usuarioListandoInterno = response.data
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    },
    listarPermissaoPorUsuario(id) {
      this.carregaTexto(this.codeMensagem('C01'))
      axios
        .get(
          this.baseUrlSeguranca + 'Menu/listarmenuusuario?usuID=' + id,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.permissaoUsuario = response.data
          this.listaGruposDoUsuario(this.allUsers)
          this.carregaTexto()
        })
        .catch((error) => {
          this.carregaTexto()
          this.setErrorSystem(error)
        })
    },

    deleteUser: function (_, item) {
      this.callConfirm(this.mensagemExcluir, item.usuid).then((result) => {
        if (result.value) {
          this.deleteUserGenerico(item)
            .then(() => {
              if (item.usuemuid > 0) {
                this.deleteEmulador(item.usuemuid)
              }
              this.$emit('usuariosListandoInterno')
              this.usuariosListandoInterno()
              this.callToast(this.mensagensUpdate.excluido, 'success')
            })
            .catch((error) => {
              this.setErrorSystem(error)
            })
        }
      })
    },
    resetarSenha: function (_, item) {
      this.callConfirm('Resetar a Senha?', item.usuid).then((result) => {
        if (result.value) {
          this.resetarSenhaGenerico(item)
            .then((response) => {
              this.callAlert('Sucesso', response.data)
            })
            .catch((error) => {
              this.setErrorSystem(error)
            })
        }
      })
    },
    boasVindas: function (_, item) {
      this.callConfirm('Reenviar e-mail?', item.usuid).then((result) => {
        if (result.value) {
          this.boasVindasGenerico(item)
            .then((response) => {
              this.callAlert('Sucesso', response.data)
            })
            .catch((error) => {
              this.setErrorSystem(error)
            })
        }
      })
    },
    limpaIntra: function () {
      this.usuarios = {}
      this.usuarioComplemento = {}
    },

    addField: function () {
      this.data.acetemdatainicio = this.dataHoraTipoSGP('08:00')
      this.data.acetemdatafinal = this.dataHoraTipoSGP('17:00')
      this.titleModal = 'Adicionar Usuário'
      this.limpaIntra()
      this.formActive = false
      this.$root.$emit('bv::show::modal', 'editUser')
    },
    changeStatus: function (_, item) {
      this.usuarios = item
      this.usuarioComplemento = item.usuariocomplemento
      this.editandoUserGenerico(item, item.usuariocomplemento)
    },
    editUser: function (_, item) {
      this.limpaIntra()
      this.titleModal = 'Editar Usuário'
      this.usuarios = item
      this.emularPermite = item.usupermiteemular
      this.usuarioComplemento = item.usuariocomplemento
      this.formActive = true
      this.$root.$emit('bv::show::modal', 'editUser')
    },

    listaPermissaoUsuario: function (_, item) {
      this.allUsers = item.usuariocomplemento.usuid

      this.nomeAdmin = item.usuariocomplemento.usucompnome
      this.listarPermissaoPorUsuario(item.usuid)
      this.printItem = item.usuid
      this.$root.$emit('bv::show::modal', 'listaPermissao')
    },
    listaGruposDoUsuario() {
      this.carregaTexto(this.codeMensagem('C01'))
      axios
        .get(
          this.baseUrlSeguranca + 'Perfil/listartodosperfilusuario',
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.userGroups = response.data
          this.carregaTexto()
        })
        .catch((error) => {
          this.carregaTexto()
          this.setErrorSystem(error)
        })
    }
  },
  created() {
    this.baseUrlSeguranca = this.$fccStore.state.baseUrlSeguranca
    this.usuariosListandoInterno()
  },
  mounted() {
    this.$root.$on('bv::modal::hide', (_, modalId) => {
      if (modalId === 'editUser') {
        this.limpaIntra()
      }
    })
  }
}
</script>
